import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=336a7fc6&"
import script from "./PriceSummary.vue?vue&type=script&lang=js&"
export * from "./PriceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Price: require('/opt/buildhome/repo/components/Price.vue').default})
